import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import CompleteDataCollectedPng from './assets/CompleteDataCollected.png'
import CompleteDataCollectedPng2x from './assets/CompleteDataCollected@2x.png'
import CompleteDataCollectedWebp from './assets/CompleteDataCollected.webp'
import CompleteDataCollectedWebp2x from './assets/CompleteDataCollected@2x.webp'

import CompleteDataCollectedMobilePng2x from './assets/CompleteDataCollectedMobile@2x.png'
import CompleteDataCollectedMobileWebp from './assets/CompleteDataCollectedMobile.webp'
import CompleteDataCollectedMobileWebp2x from './assets/CompleteDataCollectedMobile@2x.webp'

const CompleteDataCollectedImage = () => {
  const theme = useTheme()
  return (
    <>
      <picture>
        <source
          type="image/webp"
          media={theme.breakpoints.up(`sm`, false)}
          srcSet={`${CompleteDataCollectedWebp}, ${CompleteDataCollectedWebp2x} 2x`}
        />
        <source
          media={theme.breakpoints.up(`sm`, false)}
          srcSet={`${CompleteDataCollectedPng}, ${CompleteDataCollectedPng2x} 2x`}
        />
        <source
          type="image/webp"
          srcSet={`${CompleteDataCollectedMobileWebp}, ${CompleteDataCollectedMobileWebp2x} 2x`}
        />
        <Image
          src={CompleteDataCollectedMobilePng2x}
          alt="Illustration: Complete data collected across the entire customer journey"
          width="1048"
          height="539"
          loading="lazy"
        />
      </picture>
    </>
  )
}

export default CompleteDataCollectedImage
